import React from 'react';
import PropTypes from 'prop-types';
import TRCAudioContainer from '../../audio/TRCAudioContainer';
import CountdownView from '../../../common/countdown/countdownView';
import { setArPageTitle } from '../../troUtils';

export default class TRCCountdownView extends React.Component {
    constructor(props) {
        super(props);
        setArPageTitle(props.isExternalURLSourcePresent, 'Countdown');
        this.state = {
            countdownComplete: false,
            audioComplete: false,
        };
    }

    componentDidMount() {
        this.props.narrateScreen(this.props.isExternalURLSourcePresent, this.props.arLanguage);
    }

    componentDidUpdate(prevProps, prevState) {
        // When both countdown and audio are complete, proceed to next screen
        const { countdownComplete, audioComplete } = this.state;
        const bothComplete = countdownComplete && audioComplete;
        const wasBothComplete = prevState.countdownComplete && prevState.audioComplete;

        if (bothComplete && !wasBothComplete) {
            this.props.onEndCounting();
        }
    }

    componentWillUnmount() {
        this.props.cleanup();
    }

    handleCountdownComplete = () => {
        this.setState({ countdownComplete: true });
    };

    handleAudioComplete = () => {
        this.setState({ audioComplete: true });
    };

    render() {
        const { countdownTitle, cleanup, isAvatarInitialized, isPaused } = this.props;

        return (
            <div>
                <CountdownView
                    countdownTitle={countdownTitle}
                    onEndCounting={this.handleCountdownComplete}
                    cleanup={cleanup}
                    isAvatarInitialized={isAvatarInitialized}
                    initialCount={this.props.isExternalURLSourcePresent ? 5 : 3}
                    isPaused={isPaused}
                />
                <TRCAudioContainer onEndCallback={this.handleAudioComplete} />
            </div>
        );
    }
}

TRCCountdownView.propTypes = {
    cleanup: PropTypes.func,
    narrateScreen: PropTypes.func,
    countdownTitle: PropTypes.node,
    onEndCounting: PropTypes.func.isRequired,
    isAvatarInitialized: PropTypes.bool.isRequired,
    isExternalURLSourcePresent: PropTypes.bool.isRequired,
    arLanguage: PropTypes.string.isRequired,
    isPaused: PropTypes.bool.isRequired,
};

TRCCountdownView.defaultProps = {
    narrateScreen: () => {},
    cleanup: () => {},
    countdownTitle: null,
};
